import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getAllInstructors = () => apiClient.get(ENDPOINTS.INSTRUCTOR.BASE);

export const getInstructorById = (id) => apiClient.get(`${ENDPOINTS.INSTRUCTOR.BASE}/${id}`);

export const createInstructor = (instructorData) => apiClient.post(ENDPOINTS.INSTRUCTOR.BASE, instructorData);

export const updateInstructor = (id, instructorData) => apiClient.put(`${ENDPOINTS.INSTRUCTOR.BASE}/${id}`, instructorData);

export const deleteInstructor = (id) => apiClient.delete(`${ENDPOINTS.INSTRUCTOR.BASE}/${id}`);
